<template>
    <div class="main-status-setting">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Customer Assignment</h2>
                </b-col>
                <b-col cols="6" class="text-right">
                    <b-button variant="primary" class="btn-header" @click="saveModal">Save</b-button>
                </b-col>
            </b-row>
        </base-header>

        <b-container fluid class="mt--6">
            <CustomerAssignmentTable ref="childTable"></CustomerAssignmentTable>
        </b-container>
    </div>
</template>

<script>
import CustomerAssignmentTable from './CustomerAssignmentTable.vue';
import useCustomerAssignmentStore from "@/stores/customerAssignmentStore";
import Swal from "sweetalert2";
export default {
  name: "CustomerAssignmentPage",
  components: {
    CustomerAssignmentTable
  },

  data() {
    return {
      store: useCustomerAssignmentStore(),
    };
  },

   methods: {
    saveModal() {
      const flags = this.$refs.childTable.getFlags();

      this.store.setFTM(flags.TM);
      this.store.setFAdvisor(flags.Advisor);
      this.store.setFSupport(flags.Support);

      Swal.fire({
      title: 'Saved!',
      text: 'Customer assignment has been updated successfully.',
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085d6',
      timer: 2000,
      timerProgressBar: true,
    });
    }
  }
};
</script>